import { Button, Text, Flex } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { formatNumber } from "../../utils";

// import { formatNumber } from "@utils/globalCommon";

interface TicketInputRightSectionProps {
  onClick(): void;
  tokenAmount: number;
  //   maxCTA?: string;
  isConnected: boolean;
  token?: string;
}

const TicketInputRightSection = ({
  tokenAmount,
  isConnected,
  onClick,
  token,
}: TicketInputRightSectionProps) => {
  const { selectedERC20 } = useSelector((state: any) => state.user);
  return (
    <Flex flexDir="column" alignItems="flex-end">
      <Button
        bg="backgroundDivider"
        h="1.5rem"
        size="sm"
        p="4px 8px"
        _hover={{
          bg: "backgroundDivider",
        }}
        onClick={() => onClick()}
        w="41px"
        fontWeight="700"
        fontSize="10px"
        borderRadius="8px"
      >
        MAX
      </Button>

      {isConnected && tokenAmount !== undefined && tokenAmount != null ? (
        <Text fontWeight="700" fontSize="12px" mt="6px" color="textPrimary">
          Balance: {formatNumber(Number(tokenAmount), false, 4, true)}{" "}
          {token || selectedERC20}
        </Text>
      ) : null}
    </Flex>
  );
};

export default TicketInputRightSection;
